import { gql } from '@apollo/client';

export const GET_SEGMENTS_BY_BRANDKEY = gql`
  query GetSegmentsByBrandKey(
    $first: UnsignedInt!
    $where: SegmentFilterInput
    $orderBy: [SegmentOrderingInput!]
  ) {
    segments(first: $first, where: $where, orderBy: $orderBy) {
      id
      createdAt
      updatedAt
      title
      active
      device
      brandKey
      ios
      android
      editorialAlert
      status
      pushes(first: 10) {
        segment {
          title
          id
        }
      }
    }
  }
`;
